// extracted by mini-css-extract-plugin
export default {"ttModal":"TreatmentTimelineModal_ttModal__yAPW8","ttContent":"TreatmentTimelineModal_ttContent__MEzRX","ttBackdrop":"TreatmentTimelineModal_ttBackdrop__vBPUZ"};